import { BlocksIconGrid } from 'blocks-nextjs/blocks-web-components/components/icon/icons/grid';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconGrid = createComponent({ react: React, tagName: 'cat-icon-grid', elementClass: BlocksIconGrid });
